import { render, staticRenderFns } from "./ClassicalContentList.vue?vue&type=template&id=29910ff9"
import script from "./ClassicalContentList.vue?vue&type=script&lang=js"
export * from "./ClassicalContentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports